<template>
    <div class="profile">
        <Header @cart-ref="setCartRef" />
        <div id="loading-overlay" v-if="loading">
            <img src="../assets/gifs/loading.gif" alt="Carregando" class="loading-gif">
        </div>
        <div class="main-content" v-show="!loading">
            <div class="profile-container">
                <div class="tabs">
                    <span class="tab" :class="{ active: activeTab === 'dados' }" @click="activeTab = 'dados'">
                        <i class="fa-solid fa-user-pen" style="margin-right: 8px;"></i> Meus Dados
                    </span>

                    <span class="tab" :class="{ active: activeTab === 'assinaturas' }" @click="activeTab = 'assinaturas'">
                        <i class="fa-solid fa-file-invoice-dollar" style="margin-right: 8px;"></i> Compras e Assinaturas
                    </span>

                    <!-- <span class="tab" :class="{ active: activeTab === 'gerenciar' }" @click="activeTab = 'gerenciar'"
                        v-permission:role="1">
                        Gerenciar Materiais
                    </span> -->
                </div>
                <div v-if="activeTab === 'dados'">
                    <h2 class="title-profile"><i class="fa-solid fa-user-pen"></i> Meus Dados</h2>
                    <div class="profile-grid">
                        <div class="field-group">
                            <label>Usuário</label>
                            <input type="text" class="profile-input" v-model="userName" readonly>
                        </div>
                        <div class="field-group">
                            <label>Instituição</label>
                            <input type="text" class="profile-input" v-model="userInstitution" readonly>
                        </div>
                        <div class="field-group">
                            <label>E-mail</label>
                            <input type="email" class="profile-input" v-model="userEmail" readonly>
                        </div>
                        <div class="field-group" v-permission:roles="[1, 2]">
                            <label>Senha</label>
                            <input type="password" class="profile-input" value="***************" readonly>
                            <button class="btn-alterar" @click="openPasswordModal">Alterar Senha</button>
                        </div>
                    </div>
                </div>
                <div v-if="activeTab === 'assinaturas'">
                    <h2 class="title-profile"><i class="fa-solid fa-file-invoice-dollar"></i> Compras e Assinaturas</h2>
                    <div class="purchases-list">
                        <div v-for="sub in subscriptions" :key="sub.id" class="purchase-card">
                            <h3 class="purchase-date">Criada em: {{ new Date(sub.created_at).toLocaleDateString() }}</h3>
                            <hr class="divider">
                            <div class="purchase-content">
                                <div class="purchase-left">
                                    <div class="purchase-info">
                                        <p class="info-item"><strong>Status:</strong>
                                            <span :style="{ color: sub.status === 'Ativo' ? '#28a745' : sub.status === 'Cancelado' ? '#dc3545' : '#ffc107' }">
                                                {{ sub.status }}
                                            </span>
                                        </p>
                                        <p class="info-item">
                                            <strong>Material:</strong> {{ sub.nome }}
                                        </p>
                                        <p class="info-item">
                                            <strong>Preço mensal:</strong> R$ {{ sub.pagarme && sub.pagarme.price ? (sub.pagarme.price / 100).toFixed(2).replace('.', ',') : parseFloat(sub.valor).toFixed(2).replace('.', ',') }}
                                        </p>
                                        <p class="info-item" v-if="sub.proximoPagamento && sub.status === 'Ativo'">
                                            <strong>Próxima cobrança:</strong> {{ new Date(sub.proximoPagamento).toLocaleDateString('pt-BR') }}
                                        </p>
                                        <p class="info-item" v-if="sub.pagarme && sub.pagarme.current_cycle">
                                            <strong>Ciclo atual:</strong> {{ sub.pagarme.current_cycle.cycle }}º ciclo
                                        </p>
                                        <p class="info-item" v-if="sub.pagarme_subscription_id">
                                            <strong>ID Pagar.me:</strong> <small>{{ sub.pagarme_subscription_id }}</small>
                                        </p>
                                    </div>
                                </div>
                                <div class="purchase-actions" v-if="sub.status === 'Ativo'">
                                    <button class="btn-buy-again" style="background-color: #dc3545; color: white; border: none;" @click="cancelSubscription(sub.id)">
                                        Cancelar Assinatura
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-if="subscriptions.length === 0" class="no-results">
                            Nenhuma assinatura encontrada
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- Modal de Detalhes da Compra -->
        <div class="purchase-modal-overlay" v-if="showPurchaseModal">
            <div class="purchase-modal-content">
                <button class="close-btn" @click="closePurchaseModal"><i class="fa-solid fa-times"></i></button>
                <div class="modal-header">
                    <h3>Detalhes da Compra #{{ selectedPurchase.id }}</h3>
                    <span class="status-badge">{{ selectedPurchase.status }}</span>
                </div>
                
                <div class="modal-body" v-if="selectedPurchase">
                    <div class="purchase-summary">
                        <div class="summary-item">
                            <span class="label"><i class="fa-regular fa-calendar"></i> Data:</span>
                            <span class="value">{{ selectedPurchase.date }}</span>
                        </div>
                        <div class="summary-item">
                            <span class="label"><i class="fa-solid fa-credit-card"></i> Pagamento:</span>
                            <span class="value">{{ selectedPurchase.paymentMethod }}</span>
                        </div>
                        <div class="summary-item">
                            <span class="label"><i class="fa-solid fa-tag"></i> Tipo de Licenciamento:</span>
                            <span class="value">Por {{ selectedPurchase.billingType }}</span>
                        </div>
                        <div class="summary-item" v-if="selectedPurchase.billingType === 'Acessos'">
                            <span class="label"><i class="fa-solid fa-users"></i> Qtd. de Acessos:</span>
                            <span class="value">{{ selectedPurchase.accessQuantity }} acessos adquiridos</span>
                        </div>
                        <div class="summary-item" v-if="selectedPurchase.billingType === 'Faixa'">
                            <span class="label"><i class="fa-solid fa-users"></i> Faixa de Acessos:</span>
                            <span class="value">{{ selectedPurchase.accessRange }}</span>
                        </div>
                    </div>

                    <div class="materials-list">
                        <h4>Materiais Comprados</h4>
                        <table>
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Tipo</th>
                                    <th class="text-right">Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in selectedPurchase.items" :key="index">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.type }}</td>
                                    <td class="text-right">R$ {{ item.price }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="2" class="text-right"><strong>Total:</strong></td>
                                    <td class="text-right"><strong>R$ {{ selectedPurchase.total }}</strong></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                
                <div class="modal-footer">
                    <button class="btn-buy-again-modal" @click="buyAgainFromModal">Comprar de novo</button>
                </div>
            </div>
        </div>

        <div class="purchase-modal-overlay" v-if="showPasswordModal">
            <div class="purchase-modal-content">
                <button class="close-btn" @click="closePasswordModal"><i class="fa-solid fa-times"></i></button>
                <div class="modal-header">
                    <h3>Alterar Minha Senha</h3>
                </div>
                <form @submit.prevent="handlePasswordChange" class="modal-body">
                    <div class="password-modal-field">
                        <label class="password-modal-label">Nova Senha (mín. 8 caracteres)</label>
                        <div class="password-input-wrapper">
                            <input :type="showNewPassword ? 'text' : 'password'" class="profile-input password-modal-input" v-model="newPassword" required>
                            <button type="button" class="btn-toggle-visibility" @click="showNewPassword = !showNewPassword">
                                <i :class="['fa-solid', showNewPassword ? 'fa-eye-slash' : 'fa-eye']"></i>
                            </button>
                        </div>
                    </div>
                    <div class="password-modal-field">
                        <label class="password-modal-label">Confirmar Nova Senha</label>
                        <div class="password-input-wrapper">
                            <input :type="showConfirmPassword ? 'text' : 'password'" class="profile-input password-modal-input" v-model="confirmPassword" required>
                            <button type="button" class="btn-toggle-visibility" @click="showConfirmPassword = !showConfirmPassword">
                                <i :class="['fa-solid', showConfirmPassword ? 'fa-eye-slash' : 'fa-eye']"></i>
                            </button>
                        </div>
                    </div>
                    <div class="password-modal-actions">
                        <button type="button" class="btn-alterar btn-modal-cancel" @click="closePasswordModal">Cancelar</button>
                        <button type="submit" class="btn-alterar btn-modal-save" :disabled="isSavingPassword">
                            <span v-if="!isSavingPassword">Salvar Nova Senha</span>
                            <span v-else>Salvando...</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>

    </div>
</template>


<script>
import Header from '../components/Header.vue';
import request from '../router/request';
import requestV2 from '@/router/requestV2.js';
import { mapGetters } from 'vuex';

export default {
    name: 'ProfileView',

    components: {
        Header,
    },

    data() {
        return {
            activeTab: 'dados',
            showCategories: false,
            loading: true,
            pdfs: [],
            cartComponent: null,
            subscriptions: [],
            showPurchaseModal: false,
            selectedPurchase: null,
            showPasswordModal: false,
            newPassword: '',
            confirmPassword: '',
            isSavingPassword: false,
            showNewPassword: false,
            showConfirmPassword: false
        };
    },

    computed: {
        ...mapGetters([
            'currentUser',
            'userName',
            'userEmail',
            'userInstitution',
            'userRole',
            'isSystemAdmin'
        ])
    },

    methods: {
        async fetchSubscriptions() {
            try {
                const response = await requestV2.get('/subscriptions');
                this.subscriptions = Array.isArray(response.data) ? response.data : [];
            } catch (error) {
                console.error('Erro ao buscar assinaturas:', error);
            }
        },
        async cancelSubscription(id) {
            if (!confirm('Deseja realmente cancelar esta assinatura?')) return;
            try {
                this.loading = true;
                await requestV2.put(`/subscriptions/${id}/cancel`);
                alert('Assinatura cancelada com sucesso!');
                await this.fetchSubscriptions();
            } catch (error) {
                console.error('Erro ao cancelar assinatura:', error);
                const msg = error.response?.data?.message || 'Erro ao cancelar a assinatura. Tente novamente mais tarde.';
                alert(msg);
            } finally {
                this.loading = false;
            }
        },
        toggleCategories() {
            this.showCategories = !this.showCategories;
        },
        openPasswordModal() {
            this.newPassword = '';
            this.confirmPassword = '';
            this.showNewPassword = false;
            this.showConfirmPassword = false;
            this.showPasswordModal = true;
        },
        closePasswordModal() {
            this.showPasswordModal = false;
        },
        async handlePasswordChange() {
            if (this.newPassword.length < 8) {
                alert('A senha deve conter no mínimo 8 caracteres.');
                return;
            }
            if (this.newPassword !== this.confirmPassword) {
                alert('As senhas não coincidem.');
                return;
            }
            this.isSavingPassword = true;
            try {
                await requestV2.put('/usuario/senha', { password: this.newPassword });
                alert('Senha atualizada com sucesso!');
                this.closePasswordModal();
            } catch (err) {
                console.error(err);
                const msg = err.response?.data?.message || 'Erro ao alterar a senha. Tente novamente.';
                alert(msg);
            } finally {
                this.isSavingPassword = false;
            }
        },
        setCartRef(cartRef) {
            this.cartComponent = cartRef;
        },
        changeTab(tab) {
            this.activeTab = tab;
        },
        closePurchaseModal() {
            this.showPurchaseModal = false;
            this.selectedPurchase = null;
        },
        buyAgainFromModal() {
            // Stub for modal
            this.closePurchaseModal();
        }
    },

    mounted() {
        window.scrollTo(0, 0);

        const tab = this.$route.query.tab;
        if (tab) {
            this.activeTab = tab;
        }

        this.fetchSubscriptions();
        setTimeout(() => {
            this.loading = false;
        }, 1500);

        request.post('ava/listarBiblVirtual')
            .then(response => {
                const resultado = response.data;

                if (Array.isArray(resultado)) {
                    this.pdfs = resultado;
                } else if (Array.isArray(resultado?.data)) {
                    this.pdfs = resultado.data;
                } else {
                    this.pdfs = [];
                }
            })
            .catch(() => {
                this.pdfs = [];
            });
    },

    watch: {
        '$route.query.tab'(newTab) {
            if (newTab) {
                this.activeTab = newTab;
            }
        }
    }

};
</script>


<style scoped src="../styles/Profile.css" />